export enum DatePickerType {
  Range = 'range',
  Date = 'date',
  time = 'time',
  DOB = 'dateOfBirth',
}
